import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=4af39dc6&scoped=true"
var script = {}
import style0 from "./Carousel.vue?vue&type=style&index=0&id=4af39dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af39dc6",
  null
  
)

export default component.exports